import { render, staticRenderFns } from "./membersInfo.vue?vue&type=template&id=2a45c4af&scoped=true&"
import script from "./membersInfo.vue?vue&type=script&lang=js&"
export * from "./membersInfo.vue?vue&type=script&lang=js&"
import style0 from "./membersInfo.vue?vue&type=style&index=0&id=2a45c4af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a45c4af",
  null
  
)

export default component.exports